import script from "./AdminProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminProfile.vue?vue&type=script&setup=true&lang=ts"

import "./AdminProfile.vue?vue&type=style&index=0&id=2bf853ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf853ab"]])

export default __exports__